import ContactUs from "../../components/ContactUs";
import StayInLoop from "../../components/StayInLoop";
import AchieveOutcome from "../../components/AchieveOutcome/AchieveOutcome";
import WeAreIED from "../../components/WeAreIED";
import AnimatedCardCrausal from "../../components/AnimatedCardCrausal";
import IndustriesFeaturelistSection from "../../components/IndustriesFeatureListSection";
import {
    EngineeringBGVideo, ConstructionVideo, OverlayImg2,
    BusinessOutcomes,
    CommercialAssurance,
    CommissioningReadiness,
    DigitalEnablers,
    ConstructionProgress,
    EngineeringCollaboration,
    ProcurementVisibility,
    ProjectIntelligence,
    StrategicPriorities
} from "../../constant";
import ThreeLongCard from "../../components/IndustriesThreeLongCard";
import ParaVideoSection from "../../components/IndustriesParaVideoSection";
import EngineeringAndConstructionLanding from "../../components/Industries/EngineeringAndConstructionLanding";

const AnimatedCardCrausalData = [
    {
        title: "Engineering Collaboration",
        icon:EngineeringCollaboration,
        description:
            "Turning Designs into Executable Plans.",
        data: "Manage design reviews, technical approvals, document workflows, and interdisciplinary coordination throughout project execution."
    },
    {
        title: "Procurement Visibility",
        icon:ProcurementVisibility,
        description:
            "Keeping Critical Materials on Schedule",
        data: "Track procurement milestones, vendor commitments, equipment deliveries, and supply chain dependencies to reduce project delays."
    },
    {
        title: "Construction Progress",
        icon:ConstructionProgress,
        description: "Connecting Plans with Field Execution.",
        data: "Monitor site activities, work fronts, daily progress, resource deployment, and project milestones from a single source of truth."
    },
    {
        title: "Commercial Assurance",
        icon:CommercialAssurance,
        description: "Strengthening Cost and Contract Control",
        data: "Manage contractor obligations, variations, claims, commercial risks, and project commitments throughout delivery."
    },
    {
        title: "Commissioning Readiness",
        icon:CommissioningReadiness,
        description: "Preparing Assets for Startup.",
        data: "Coordinate testing activities, punch lists, readiness reviews, documentation, and handover requirements before operations begin."
    },
    {
        title: "Project Intelligence",
        icon:ProjectIntelligence,
        description: "Improving Delivery Decisions",
        data: "Bring together engineering, procurement, construction, quality, and schedule information to support proactive project management."
    },

];

const longCardData = [
    {
        title: "Strategic Priorities",
        icon:StrategicPriorities,
        listItems: [
            "Predictable Project Delivery",
            "Workforce Safety Excellence",
            "Schedule Adherence",
            "Cost Control",
            "Quality Assurance",
        ],
    },
    {
        title: "Digital Enablers",
        icon:DigitalEnablers,
        listItems: [
            "Digital Project Controls",
            "Connected Field Workforce",
            "Contractor Management",
            "BIM & Digital Twin Integration",
            "Advanced Analytics & AI",
        ],
    },
    {
        title: "Business Outcomes",
        icon:BusinessOutcomes,
        listItems: [
            "Reduced Schedule Slippage",
            "Improved Field Productivity",
            "Faster Issue Resolution",
            "Greater Cost Transparency",
            "Higher Project Certainty",
        ],
    },
];


const featurelist = {
    listTitle: "Creating the Digital Foundation for Project Excellence",
    listSubTitle: [
        "The engineering and construction sector is entering a new era where data transparency, execution discipline, and connected workflows determine project success.",
        "IENERGY enables project teams to move beyond reactive management by providing real-time visibility into schedule performance, resource utilization, field productivity, contractor effectiveness, and project risk.",
        "Our digital solutions create alignment between office and site operations, helping organizations improve decision-making, accelerate execution, and strengthen delivery confidence from design through commissioning.",
        "The result is greater project predictability, improved stakeholder confidence, and stronger returns on capital investments."
    ],
    listItems: []
}

const leftSecionData = {
    title: "Navigating Complexity with Confidence",
    para: ["IENERGY helps organizations establish a connected operating model that improves project oversight, strengthens governance, and supports timely intervention when issues arise. By bringing together project controls, workforce activities, contractor performance, quality processes, and field execution, organizations can improve predictability, accelerate delivery, and create greater confidence in project outcomes."],
    listItems: [
        "Improve coordination across engineering, procurement, construction, and commissioning activities.",
        "Strengthen oversight of contractors, project commitments, and critical milestones.",
        "Reduce schedule disruption through earlier identification of project risks and execution bottlenecks.",
        "Improve resource utilization and workforce productivity across project sites.",
        "Enable more informed decisions through timely access to project and field information.",
    ],
    mediaUrl: ConstructionVideo,
    imgeUrl: OverlayImg2,
}



export default function EngineeringAndConstructionPage() {
    return (
        <>
            <EngineeringAndConstructionLanding />
            <AnimatedCardCrausal
                title={"Delivering Certainty Across Complex Projects"}
                subTitle={"From concept to commissioning, project success depends on coordination across engineering, procurement, construction, contractors, and project stakeholders. iEnergy helps organizations strengthen execution discipline, improve project governance, and maintain control across the entire project lifecycle."}
                data={AnimatedCardCrausalData}
            />
            <ParaVideoSection
                title={"Reimagining Project Delivery for a New Era"}
                subTitle={"The engineering and construction sector is facing unprecedented pressure to deliver larger, more complex projects amid rising costs, tighter schedules, evolving stakeholder expectations, and increasing regulatory scrutiny."}
                data={leftSecionData}
            />
            <ThreeLongCard
                title={"Accelerating Project Delivery Through Digital Execution"}
                subTitle={"Unify engineering, procurement, construction, and commissioning activities through connected workflows, real-time visibility, and data-driven project controls."}
                data={longCardData}
            />
            <IndustriesFeaturelistSection data={featurelist} backgroundItem={EngineeringBGVideo} />
            <AchieveOutcome
                title={`Turning Project Complexity into Execution Advantage`}
                subTitle={`Leading project organizations are rethinking how engineering, procurement, and field activities are managed. By connecting information across the project lifecycle, IENERGY helps teams reduce uncertainty, accelerate decision-making, and improve delivery outcomes at scale.`}
            />

            <WeAreIED />
            <ContactUs />
            <StayInLoop />
        </>
    );
}
